export const CATEGORY_DATA_SUCCESS = "CATEGORY_DATA_SUCCESS";
export const LOADING_CATEGORY_DATA = "LOADING_CATEGORY_DATA";
